<template>
	<ul class="uk-grid-match instructions" uk-grid>
		<li class="uk-width-1-3@s">
			<div>
				<label v-if="$parent.user.role.code == 'teacher'">
					<span class="l_title">Количество игроков: </span>
					<div class="plm">
						<div class="plm__button plm__button--minus" @click="$parent.addUsers('-')"></div>
						<input type="number" min="1" max="8" :readonly="role == 'teacher' ? false : true" v-model="users">
						<div class="plm__button plm__button--plus" @click="$parent.addUsers('+')"></div>
					</div>
				</label>

				<settings :inparams="params" :ingame="false" @params_changed="params_changed"></settings>

				<button class="uk-button uk-button-primary" @click="$parent.commitVal(true, 'start')">СТАРТ!</button>
			</div>
		</li>
		<li class="uk-width-2-3@s">
			<div>
				<div class="wh-block__wrap">
					<div class="wh-block__desc" v-html="item.instruction"></div>
					<div class="wh-block__pic"><img :src="item.inner_image.path" alt=""></div>
				</div>
			</div>
		</li>
	</ul>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';
  import Select2 from "v-select2-component";
  import settings from "./components/Settings";

  export default {
    name: "instructions",
    components: { Select2, settings },
    data() {
      return {}
    },
    computed: {
      users: {
        get() {
          return this.$store.state.train.flash_params.users
        },
        set(value) {
          this.$parent.commitVal(value, 'users');
        }
      },
      role() {
        return this.$store.state.user.role.code;
      },

      ...mapState({
        item: 'current_trainer',
        params: state => state.train.flash_params
      })

    },
    methods: {
      params_changed(params){
        let val = {
          'params': params,
          'train': 'flash_params'
        }
        this.$store.commit('train/changeParams', val);
      },
      addQnt(val, param, param2) {
        if (!param2) {
          if (val === '+') {
            this[param]++;
          } else if (this[param] > 1) {
            this[param]--;
          }
        } else {
          if (val === '+') {
            this[param][param2]++;
          } else if (this[param][param2] > 1) {
            this[param][param2]--;
          }
        }
      },

    },
	  mounted() {
      this.$store.commit('shuffleColors');
    }
  }
</script>
